const lazyLoadImages = require("../lazy-load/ImageLazyLoad").default;
import BrowserDetect from "../utils/BrowserDetect";
import Tracking from "../analytics/Tracking";

/**
 * Scan all modals in the DOM, move them to the DOM top level and attach some code to them
 *
 * In order to create a Modal, you need to have DOM element with a "data-modal-for" attribute  which will references the id of the modal div.
 *
 * Example :
 *  <button data-modal-for="modal-id"></button>
 *  <div id="modal-id" class="modal"></div>
 */

export default function initModal(selector = "") {

    $(function () {

        let isScrolled = false;

        // Move every modal in top level of the DOM to avoid z-index issue
        $(`${selector} .modal`).each(function (i, modal) {
            $(modal).appendTo(document.body);
        });

        // Show/hide logic
        $(`${selector} [data-modal-for]`).each(function (i, e) {

            let scrollTimer;
            let scrollY;
            let lastScrollY = $(`${selector} .modal>div:last-child`).scrollTop();
            let $gallery = $(".modal");
            let scrolledState = "modal--scrolled";
            let modalId = $(e).attr("data-modal-for");
            let modal = $(`#${modalId}`);
            let modalContainer = $(modal).find(".picture-gallery-modal-container");
            let modalScrollTarget = $(`#${modalId}>div:last-child`);
            let modalBg = $(modal).find(".modal__bg");
            let closeButton = (modal).find(".modal__inner__header__close");
            let closeButtonNewsletter = (modal).find("#modal__inner__header__close");
            let closeButtonHardPaywall = (modal).find("#hpwModalClose");


            let handleScroll = function() {
              scrollY = modalScrollTarget.scrollTop();
              updateTutorialState();
              lastScrollY = scrollY;
            }

            let updateTutorialState = function() {
              if(lastScrollY > 150 && !isScrolled) {
                isScrolled = true;
                $gallery.addClass(scrolledState);
              }
            }

            let pictureScrollHandler = function() {
              updateTutorialState();
                modalScrollTarget.scroll(function () {
                    cancelAnimationFrame(scrollTimer);
                    if(!isScrolled)
                      scrollTimer = requestAnimationFrame(handleScroll);
                });
            };

            let loadModalImages = function() {
                // Force loading lazy pictures inside modal on Edge
                if(BrowserDetect.isEdge()) {
                    let lazyLoadedModalPictures = Array.from(document.querySelectorAll(`#${modalId} img[data-src]`));
                    let lazyLoadInstance = lazyLoadImages(`#${modalId}`);

                    if(lazyLoadedModalPictures && lazyLoadInstance) {
                        lazyLoadedModalPictures.map( picture => lazyLoadInstance.load(picture, true) );
                    }
                }
            };

            let showModal = function() {
                window.logAction();

                pictureScrollHandler();
                loadModalImages(modal);
                modal.addClass("modal--show");
                if(isScrolled)
                  modal.addClass("modal--scrolled");
                $("body, .body-wrapper").addClass("u-disable-scroll");
                //if(selector === ".newsletter-page") $("body").addClass("newsletter-preview__disable-scroll");

                return false;
            }

            let hideModal = function () {
                $gallery.removeClass(scrolledState);
                modal.removeClass("modal--show");
                $("body, .body-wrapper").removeClass("u-disable-scroll");
                // Reset scroll after hidding the modal
                modalContainer.scrollTop(0);
                
                if(modal.attr("class").indexOf("hard-paywall-modal") !== -1 && window.hardPaywallTrackingData) {
                    Tracking.track("action.hpwOverlay-closeBtn", window.hardPaywallTrackingData);
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'UniversalEvent',
                        'eventCategory': `${window.hardPaywallTrackingData.editionId === "en" ? "LT+" : "Wort+"} | Overlay`,
                        'eventAction': 'Click',
                        'eventLabel': 'close'
                    });
                }

                return false;
            }

            // Open modal handlers
            $(e).click(showModal.bind(this));

            // Close modal handlers
            modalBg.click(hideModal.bind(this));
            closeButton.click(hideModal.bind(this));
            closeButtonNewsletter.click(hideModal.bind(this));
            closeButtonHardPaywall.click(hideModal.bind(this));

            // Scroll to element inside modal on click
            $(e).find(`${selector} [data-modal-scroll-to]`).each(function (j, scrollToTriggerEl) {
                let scrollToId = $(scrollToTriggerEl).attr("data-modal-scroll-to");
                let scrollToElement = $(modal).find(`[data-modal-scroll-id="${scrollToId}"]`);

                if(scrollToElement) {
                    $(scrollToTriggerEl).click(function () {
                        modalContainer.scrollTop($(scrollToElement).position().top);
                    });
                }
            });

            document.addEventListener("keydown", function (keyEvent) {
                if (keyEvent.which === 27) { // Pressing "Escape" key
                    hideModal(modal);
                }
            });
        });
    });
}

window.initModal = initModal;



// WEBPACK FOOTER //
// ./js/modal/Modal.js